import React, { useState, useEffect, useMemo } from 'react'
import useScreen from '../../hooks/useScreen'
import { CheckCircleIcon } from '@heroicons/react/outline'
import Close from '../../svg/Close'

const SuccessActionMessage = () => {
    const { isMobile, isTablet } = useScreen()
    const [showMessage, setShowMessage] = useState(
        localStorage.getItem('showSuccessMessage') === 'true',
    )
    const [action, setAction] = useState(localStorage.getItem('successAction'))

    useEffect(() => {
        const handleStorageChange = () => {
            const newAction = localStorage.getItem('successAction')
            const newShowMessage =
                localStorage.getItem('showSuccessMessage') === 'true'

            setAction(newAction)
            setShowMessage(newShowMessage)
        }

        // Listen for localStorage changes
        window.addEventListener('storage', handleStorageChange)

        return () => {
            window.removeEventListener('storage', handleStorageChange)
        }
    }, [])

    // Auto-hide message after 5 seconds when showMessage is true
    useEffect(() => {
        if (showMessage) {
            const timer = setTimeout(() => {
                setShowMessage(false)
                localStorage.setItem('showSuccessMessage', 'false')
            }, 5000)

            return () => clearTimeout(timer)
        }
    }, [showMessage])

    const message = useMemo(() => `Request successfully ${action}`, [action])

    if (!showMessage) return null

    return (
        <div
            className={`fixed right-0 p-0 z-50 ${
                isMobile || isTablet ? `bottom-0 w-full` : `bottom-0 w-96`
            }`}
        >
            <div className="absolute bottom-full right-0 md:w-96 w-full h-auto bg-successBg">
                <div className="w-full h-full gap-x-3.5 border-l-4 p-4 border-green-600 flex items-top justify-between">
                    <div className="flex items-center gap-x-3.5">
                        <CheckCircleIcon className="text-green-600 w-5 h-5" />
                        <p className="text-textDarkerGray font-medium text-sm">
                            {message}
                        </p>
                    </div>
                    <Close
                        onClick={() => {
                            setShowMessage(false)
                            localStorage.setItem('showSuccessMessage', 'false')
                        }}
                        className="cursor-pointer"
                    />
                </div>
            </div>
        </div>
    )
}

export default SuccessActionMessage
